import { render, staticRenderFns } from "./DeepLinkView.vue?vue&type=template&id=10bdede2&"
import script from "./DeepLinkView.vue?vue&type=script&lang=js&"
export * from "./DeepLinkView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports